var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgGoldenGlobe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 185,
    viewBox: "0 0 184 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_945_1833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.253 112.924C189.356 65.2112 159.678 17.5317 111.966 6.42858C64.253 -4.6745 16.5734 25.0034 5.47036 72.716C-5.63272 120.429 24.0452 168.108 71.7578 179.211C119.47 190.314 167.15 160.636 178.253 112.924Z",
    stroke: "#E9AE25",
    strokeWidth: 2.33054,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8028 183.032C127.23 183.032 154.327 143.32 154.327 94.3328C154.327 45.3453 127.23 5.63306 93.8028 5.63306C60.3761 5.63306 33.2783 45.3453 33.2783 94.3328C33.2783 143.32 60.3761 183.032 93.8028 183.032Z",
    stroke: "#E9AE25",
    strokeWidth: 2.33054,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.803 183.032C107.251 183.032 118.152 143.32 118.152 94.3328C118.152 45.3453 107.251 5.63306 93.803 5.63306C80.3555 5.63306 69.4541 45.3453 69.4541 94.3328C69.4541 143.32 80.3555 183.032 93.803 183.032Z",
    stroke: "#E9AE25",
    strokeWidth: 2.33054,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.284 47.3743H18.321",
    stroke: "#E9AE25",
    strokeWidth: 2.33054,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.503 94.3328H4.75562",
    stroke: "#E9AE25",
    strokeWidth: 2.33054,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.284 140.944H18.321",
    stroke: "#E9AE25",
    strokeWidth: 2.33054,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_945_1833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 184.53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenGlobe);
export default __webpack_public_path__ + "static/media/goldenGlobe.ace83ac19d3b40db4141518e02dc9dbb.svg";
export { ForwardRef as ReactComponent };